import { render, staticRenderFns } from "./orphaned-payments.vue?vue&type=template&id=54364e6e"
import script from "./orphaned-payments.vue?vue&type=script&lang=js"
export * from "./orphaned-payments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports